import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InstructorHome from "../Instructor/InstructorHome";
import LearnerHome from "../Learner/LearnerHome";
import { useMyContext } from "../../store/ContextApi";
import { isIn } from "validator";
import AdminHome from "../Admin/AdminHome";

const Home = () => {
  const { isInstructor, isLearner, isAdmin, token, currentUser } =
    useMyContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else if (token && currentUser) {
      setIsLoading(false);
    }
  }, [token, currentUser]);

  return (
    <div>
      {isInstructor && <InstructorHome />}
      {isLearner && <LearnerHome />}
      {isAdmin && <AdminHome />}
    </div>
  );

  // const dispatch = useDispatch();
  // const jwt = localStorage.getItem("jwt");
  // const navigate = useNavigate();
  // const { auth } = useSelector((store) => store);
  // useEffect(() => {
  //   // dispatch(getLearner());
  //   if (!jwt) navigate("/");
  //   if (jwt) {
  //     dispatch(getUser(jwt));
  //   }
  // }, [jwt]);
  // return (
  //   <div>
  //     {auth.user?.role === "ROLE_INSTRUCTOR" && <InstructorHome />}
  //     {auth.user?.role === "ROLE_LEARNER" && <LearnerHome />}
  //   </div>
  // );
};

export default Home;
